import { render, staticRenderFns } from "./CategoryAbout.vue?vue&type=template&id=aa6b9254&"
import script from "./CategoryAbout.vue?vue&type=script&lang=js&"
export * from "./CategoryAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports